require([
	'jquery',
	'base/MbiMediaQuery',
	'project/Vendor/lib/greensock/TweenMax',
	'project/Vendor/lib/greensock/plugins/ScrollToPlugin',
	'ScrollMagic',
	'project/Vendor/gsap',
	'project/Vendor/addIndicators'

	// // //'root/Assets/Templates/Content/ParallelScroll/Js/Vendor/ScrollToPlugin',
	//  'root/Assets/Templates/Content/ParallelScroll/Js/Vendor/plugins/addIndicators'

	
], function($,mbiMq,tm,ScrollToPlugin,ScrollMagic,gsap
	
	
) {
	'use strict';

	
	// var controller = new ScrollMagic.Controller({globalSceneOptions: {duration: "100%"}});
	// var initScroll = function() {
	// 	$('.js_scroll-trigger').each(function(){
					
	// 		var secondScene = new ScrollMagic.Scene({
	// 			duration: '100%',
	// 			triggerHook: 'onEnter',
	// 			//reverse: false,
	// 			triggerElement: this })
	// 				//.setClassToggle(this,'in-view',0.5)
	// 				.setTween(TweenMax.from(this, 1, {y: "20%", opacity: 0, ease: Linear.easeNone}, 0.25))
	// 				.addTo(controller); 

	// 	});

		
	// }
	// if ($('.js_scroll-trigger').length > 0) {

	// 	initScroll();
	// }
	
	
	
});
define("root/Assets/Templates/Content/OpenPositions/Js/OpenPositions", function(){});

